import ACTIONS_REPORT_SCHEDULE from '../_constants/reportSchedule.constants';

const initialState = {
  byId: {},
};

export function reportScheduleReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_REPORT_SCHEDULE.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_REPORT_SCHEDULE.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_REPORT_SCHEDULE.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default reportScheduleReducer;
